<template>
  <div fluid class="pa-0 col-12 justify-center">
    <v-app-bar flat color="red-darken-3">
      <v-app-bar-title class="hidden-sm-and-down">
        {{ $t("edit_ebay_categories.title") }}
      </v-app-bar-title>
      <v-divider class="mx-5 hidden-sm-and-down" inset vertical />
    </v-app-bar>
    <div v-if="loading" class="col-12 mt-5 text-center justify-center">
      <v-progress-circular color="#D32F2F" indeterminate size="100" />
    </div>
    <v-row v-else class="pa-3 pt-5">
      <v-col cols="12" class="mb-5 d-flex flex-nowrap">
        <v-col cols="6" md="5" lg="5">
          <label>{{ $t("edit_ebay_categories.part_title") }}</label>
          <v-autocomplete
            v-model="selectedPart"
            :loading="loading"
            :items="categories"
            :label="$t('parts.inventory.search')"
            item-title="title_it"
            variant="solo"
            color="red-darken-1"
            append-inner-icon="mdi-magnify"
            class="mr-2"
            single-line
            hide-details
            hide-no-data
            return-object
            clearable
            @change="onPartSelected"
          />
        </v-col>
        <v-col cols="6" md="3" lg="3">
          <label>{{ $t("edit_ebay_categories.part_code") }}</label>
          <v-text-field
            v-model="selectedPart.partCode"
            type="number"
            hide-details
            variant="solo"
            class="mr-2 mb-1"
            readonly
          />
        </v-col>
        <v-col cols="6" md="3" lg="3">
          <label>{{ $t("edit_ebay_categories.part_category") }}</label>
          <v-text-field
            v-model="selectedPart.category_it"
            hide-details
            variant="solo"
            class="mr-2 mb-1"
            readonly
          />
        </v-col>
      </v-col>
      <v-col cols="12" class="d-flex flex-nowrap">
        <v-col v-if="selectedPart.ebayCode" cols="6" md="3" lg="3">
          <label
            >{{ $t("edit_ebay_categories.ebay_code")
            }}<small>(CategoryId)</small></label
          >
          <v-text-field
            v-model="selectedPart.ebayCode"
            hide-details
            variant="solo"
            class="mb-1"
          />
        </v-col>
        <v-col v-else cols="6" md="3" lg="3">
          <label
            >{{ $t("edit_ebay_categories.ebay_code") }}
            <small>(CategoryId)</small></label
          >
          <v-autocomplete
            v-model="ebayCode"
            :items="ebayCategories"
            :label="$t('parts.inventory.search')"
            item-title="CategoryId"
            variant="solo"
            color="red-darken-1"
            append-inner-icon="mdi-magnify"
            class="mr-2"
            single-line
            hide-details
            hide-no-data
            return-object
            :disabled="!selectedPart.partCode"
            @update:model-value="onCategorySelected"
          />
        </v-col>
        <v-col
          v-if="selectedPart.ebayCategoryIt && selectedPart.ebayCode"
          cols="6"
          md="4"
          lg="4"
        >
          <label
            >{{ $t("edit_ebay_categories.ebay_category") }} -
            {{ $t("edit_ebay_categories.part_title") }}</label
          >
          <v-text-field
            v-model="selectedPart.ebayCategoryIt"
            hide-details
            variant="solo"
            class="mr-2 mb-1"
            readonly
          />
        </v-col>
        <v-col v-else cols="6" md="4" lg="4">
          <label
            >{{ $t("edit_ebay_categories.ebay_category") }} -
            {{ $t("edit_ebay_categories.part_title") }}</label
          >
          <v-text-field
            v-model="ebayCategoryIt"
            hide-details
            variant="solo"
            class="mr-2 mb-1"
            readonly
          />
        </v-col>
        <v-col cols="4" class="mt-4 justify-end text-end ml-auto d-flex">
          <v-btn
            :loading="loadingSave"
            color="#D32F2F"
            outlined
            class="mt-4 ml-auto white--text"
            :disabled="!requiredFields"
            @click="saveChanges"
          >
            {{ $t("tests.form.save") }}
          </v-btn>
        </v-col>
      </v-col>
      <v-col class="mt-4">
        <div>
          <v-col xs="12" sm="11" md="12" lg="12">
            <div>
              <v-alert
                :value="true"
                type="error"
                border="bottom"
                class="mt-3"
                variant="tonal"
                text
              >
                {{ $t("update_ebay_category") }}
              </v-alert>
            </div>
          </v-col>
          <small class="ml-3"> **** {{ $t("leaf_category_info") }}</small>
        </div>
      </v-col>
    </v-row>
    <v-dialog v-model="success" max-width="300">
      <v-alert v-model="success" type="success" dismissible :value="true">
        {{ $t("institutions.form.success") }}
      </v-alert>
    </v-dialog>
    <v-dialog v-model="error" max-width="300">
      <v-alert v-model="error" type="error" dismissible :value="true">
        {{ $t("Error") }}
      </v-alert>
    </v-dialog>
  </div>
</template>

<script>
import getRequest from "../api/getRequest";
import putRequest from "../api/putRequest";

export default {
  data: () => ({
    loading: false,
    success: false,
    error: false,
    categories: [],
    headers: [
      { text: "Leaf", value: "Leaf" },
      { text: "Category ID", value: "CategoryId" },
      { text: "Level", value: "Level" },
      { text: "Compatibility", value: "Compatibility" },
      { text: "Breadcrumb", value: "Breadcrumb" },
      { text: "L1", value: "L1" },
      { text: "L2", value: "L2" },
      { text: "L3", value: "L3" },
      { text: "L4", value: "L4" },
      { text: "L5", value: "L5" },
      { text: "L6", value: "L6" },
    ],
    loadingSave: false,
    selectedPart: {
      title_it: "",
      partCode: "",
      ebayCategoryIt: "",
      ebayCode: "",
      category_it: "",
    },
    ebayCategories: [],
    ebayCategoryIt: null,
    ebayCode: null,
  }),
  computed: {
    requiredFields() {
      return (
        this.selectedPart.category_it &&
        (this.selectedPart.ebayCode || this.ebayCode) &&
        (this.selectedPart.ebayCategoryIt || this.ebayCategoryIt)
      );
    },
  },
  async created() {
    await this.getLekoEbayCategories();
    this.getEbayCategories();
  },
  methods: {
    getLekoEbayCategories() {
      this.loading = true;
      getRequest("/list-ebay-categories/leko")
        .then((response) => {
          if (response && response.parts) {
            this.categories = response.parts;
          } else {
            this.categories = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getEbayCategories(part) {
      this.loading = true;
      getRequest("/list-ebay-categories/")
        .then((response) => {
          if (response && response.ebayCategories) {
            this.ebayCategories = response.ebayCategories.filter((p) => p.Leaf);
            if (part) {
              this.onPartSelected(part);
            }
          } else {
            this.ebayCategories = [];
          }

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    saveChanges() {
      this.loadingSave = true;
      const part = {
        title: this.selectedPart.title_it,
        partCode: this.selectedPart.partCode,
        ebayCode: this.selectedPart.ebayCode || this.ebayCode.CategoryId,
        ebayCategoryIt: this.ebayCategoryIt
          ? this.ebayCategoryIt || this.ebayCategoryIt.CategoryTitle
          : this.selectedPart.ebayCategoryIt,
        category: this.selectedPart.category_it,
      };
      putRequest("/list-ebay-categories/leko/edit", "", part)
        .then((response) => {
          if (response) {
            this.success = true;
            this.ebayCategoryIt = "";
            this.ebayCode = "";
            this.getLekoEbayCategories(part);

            setTimeout(() => {
              this.success = false;
            }, 3000);
          }
        })
        .catch(() => {
          this.error = true;
          setTimeout(() => {
            this.error = false;
          }, 3000);
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },
    onPartSelected(part) {
      if (!part || !part.partCode) return;

      const full = this.categories.find((p) => p.partCode === part.partCode);
      if (full) {
        this.selectedPart = { ...full };
        this.ebayCategoryIt = "";
        this.ebayCode = "";
      }
    },
    onCategorySelected(category) {
      if (!category) return;
      const full = this.ebayCategories.find(
        (p) => p.CategoryId === category.CategoryId,
      );
      if (full) {
        this.ebayCode = { ...full };
        this.ebayCategoryIt = full.CategoryTitle;
      }
    },
  },
};
</script>
